export default __webpack_public_path__ + "static/media/base-report2.c4aa7c1f.png";